/**
 * Analytics constants - tab names, menu items, etc.
 * Use these instead of magic strings for consistent event properties.
 */

export const ANALYTICS_TABS = {
  ARENA: 'arena',
  SCOREBOARD: 'scoreboard',
  FRIENDS: 'friends',
  WORLD_CUP: 'worldcup',
} as const

export const ANALYTICS_MENU_ITEMS = {
  PRIVACY_AND_DATA: 'privacy_and_data',
  PRIVACY_POLICY_MODAL: 'privacy_policy_modal',
  PRIVACY_DATA_DELETION_MODAL: 'privacy_data_deletion_modal',
  PRIVACY_TERMS_MODAL: 'privacy_terms_modal',
  PRIVACY_CREDITS_MODAL: 'privacy_credits_modal',
  PRIVACY_ACCOUNT_DELETION_HUB: 'privacy_account_deletion_hub',
  PRIVACY_DATA_CONTROLS: 'privacy_data_controls',
  PRIVACY_DATA_EXPORT: 'privacy_data_export',
  PRIVACY_MARKETING_CONSENT: 'privacy_marketing_consent',
  TUTORIAL: 'tutorial',
  WORLD_CUP_RULES: 'world_cup_rules',
  OFFICIAL_WEBSITE: 'official_website',
  REDEEM_COUPON: 'redeem_coupon',
  SIGN_OUT: 'sign_out',
  CANCEL: 'cancel',
} as const
